import { render, staticRenderFns } from "./radioGroup.vue?vue&type=template&id=dd72420a"
import script from "./radioGroup.vue?vue&type=script&lang=js"
export * from "./radioGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports